import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Link from 'components/atoms/Link';
import { appendQueryParams } from 'utils/bundle-helper';
import { LinkButton } from 'components/atoms/Button';
import * as styles from './ProductFilter.scss';

export const FilterItem = ({
  filter,
  type,
  active,
  compact,
  filterQuery,
  url,
  handleSetFilter,
  filtersActive,
}) => {
  let filterIds;
  if (Object.prototype.hasOwnProperty.call(filter, 'tellusCategoryIds')) {
    filterIds = [...filter.tellusCategoryIds];
  } else {
    filterIds = filter.id;
  }
  const isFilterActive = useCallback(() => {
    const typeExists =
      filtersActive &&
      Object.prototype.hasOwnProperty.call(filtersActive, type);
    return typeExists && filtersActive[type].includes(filterIds.toString());
  }, [filtersActive, type, filterIds, isSelected]);

  const handleFilterClick = () => {
    let newActiveFilters = { ...filtersActive };

    if (newActiveFilters[type]) {
      if (isFilterActive()) {
        newActiveFilters[type] = filtersActive[type]
          .replace(filterIds.toString(), '')
          .split(',')
          .filter(item => item !== '')
          .toString();

        newActiveFilters = Object.keys(newActiveFilters).reduce(
          (obj, key) => ({
            ...obj,
            ...(newActiveFilters[key] !== '' && {
              [key]: newActiveFilters[key],
            }),
          }),
          {},
        );
      } else if (Array.isArray(filterIds)) {
        filterIds.forEach(id => {
          newActiveFilters[type] += `,${String(id)}`;
        });
      } else {
        newActiveFilters[type] += `,${filterIds}`;
      }
    } else {
      newActiveFilters[type] = filterIds.toString();
    }
    handleSetFilter(newActiveFilters);
  };

  const [isSelected, setIsSelected] = useState(isFilterActive());

  useEffect(() => {
    setIsSelected(isFilterActive());
  }, [isFilterActive, isSelected]);

  if (compact) {
    return (
      <LinkButton
        key={filter.id}
        className={classnames(styles.link, {
          [styles.compact]: compact,
          [styles.selected]: isSelected,
        })}
        onClick={handleFilterClick}
        full
      >
        {filter.name}
      </LinkButton>
    );
  }
  return (
    <Link
      className={classnames(styles.link, {
        [styles.selected]: active,
      })}
      href={
        appendQueryParams(
          url,
          {
            [type]: filterQuery.join(','),
          },
          true,
        ).href
      }
      data-no-scrolltop
    >
      {filter.name}
    </Link>
  );
};

FilterItem.propTypes = {
  filter: PropTypes.shape({
    children: PropTypes.array,
    id: PropTypes.string,
    key: PropTypes.number,
    name: PropTypes.string,
    parentID: PropTypes.number,
    productType: PropTypes.string,
    tellusCategoryIds: PropTypes.arrayOf(PropTypes.string),
    useDefaultFilter: PropTypes.bool,
  }),
  type: PropTypes.string,
  active: PropTypes.bool,
  compact: PropTypes.bool,
  url: PropTypes.object,
  filterQuery: PropTypes.arrayOf(PropTypes.string),
  handleSetFilter: PropTypes.func,
  filtersActive: PropTypes.object,
};

export default FilterItem;
